// Written by desktop/scripts/stamp-version.js. Do not edit by hand.
export const VERSION = "0.9.248";
export const BUILT_AT = "5 nov 15:16";
export const BUILT_AT_ISO = "2026-11-05T14:16:06.730Z";
